module.exports = __webpack_public_path__ + "static/media/questionsPageNotLogged.6e24c980.jpg";